export enum Urls {
    routeToSonic = 'https://app.sonic.ooo/swap?from=ICP&to=utozz-siaaa-aaaam-qaaxq-cai',
  }